import React from 'react'
import './other.less'
import {GiLotus} from 'react-icons/gi'

export default ()=>{
    return(
        <section className="other-areas">
            <article>
                <div className="heading">
                    <h2>other areas</h2>
                    <div className="underline"></div>
                </div>
                <div className="other-summ">
                    <p>
                        We have dedicated ourselves to identify various ways we can add value to our community along with our core objectives. Some of the ideas we will be implementing are to create a platform where people from different stages of life share their experiences and concerns so that we can all learn from each other. Along with that we will be initiating projects to support education and safe sanitation once the circumstances allow. Our virtual platforms are available to connect, get in touch, and to build our community
                    </p>
                </div>
                <article className="points">
                    <div className="single-point anim-two" data-delay="0s">
                        <span>
                            <GiLotus/>
                        </span>
                        <p>
                            Love & Relationships
                        </p>
                    </div>
                    <div className="single-point anim-two" data-delay="0.2s">
                        <span>
                            <GiLotus/>
                        </span>
                        <p>
                            Mental & physical Areas
                        </p>
                    </div>
                    <div className="single-point anim-two" data-delay="0.4s">
                        <span>
                            <GiLotus/>
                        </span>
                        <p>
                            Social Topics
                        </p>
                    </div>
                    <div className="single-point anim-two" data-delay="0.6s">
                        <span>
                            <GiLotus/>
                        </span>
                        <p>
                            Human Interests
                        </p>
                    </div>
                </article>
                <article className="join-blog anim-two" data-delay="0.8s">
                    <p>
                        Visit Our Blog, Where The Community Talks About Their Issues
                    </p>
                    <a href="https://theempowerinitiative.lk/blog_wp/blog/" className="btn">Blog</a>
                </article>
            </article>
        </section>
    )
}